module.exports = __webpack_public_path__ + "static/img/3-1.fa7fb97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengjian/paixu/3-1.png
// module id = Y0Ai
// module chunks = 6